import axios from '../../utils/axiosConfig';
import { Contexture } from '../Contexture/Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/application/technologies`;

export class Technologies {
  static async fetchAll(params) {
    try {
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchByType(type, params) {
    try {
      if (type !== 'stack' && type !== 'tool') {
        throw new Error("Invalid type. Must be 'stack' or 'tool'");
      }

      const response = await axios.get(`${BASE_URL}/type/${type}`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchByNameAndType(name, type, params) {
    try {
      if (type !== 'stack' && type !== 'tool') {
        throw new Error("Invalid type. Must be 'stack' or 'tool'");
      }

      const response = await axios.get(
        `${BASE_URL}/${encodeURIComponent(name)}/${type}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async create(technology, params) {
    try {
      if (!technology.name || !technology.type) {
        throw new Error('Missing required fields: name and type');
      }

      if (technology.type !== 'stack' && technology.type !== 'tool') {
        throw new Error("Invalid type. Must be 'stack' or 'tool'");
      }

      const response = await axios.post(`${BASE_URL}`, technology, {
        headers: {
          ...Contexture.getHeaders(),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async update(name, type, updates, params) {
    try {
      if (type !== 'stack' && type !== 'tool') {
        throw new Error("Invalid type. Must be 'stack' or 'tool'");
      }

      if (updates.type && updates.type !== 'stack' && updates.type !== 'tool') {
        throw new Error("Invalid type. Must be 'stack' or 'tool'");
      }

      const response = await axios.put(
        `${BASE_URL}/${encodeURIComponent(name)}/${type}`,
        updates,
        {
          headers: {
            ...Contexture.getHeaders(),
            'Content-Type': 'application/json',
          },
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async delete(tech_id, params) {
    try {
      if (!tech_id) {
        throw new Error('tech_id is required');
      }

      const response = await axios.delete(
        `${BASE_URL}/${encodeURIComponent(tech_id)}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
